// extracted by mini-css-extract-plugin
export default {"goBack":"BackButton_goBack__yjAty"};